<template>
  <span class="gam-rating-dots">
    <span v-for="d in dotCount" :key="d" class="rating-dot filled" />
    <span v-for="d in maxDots - dotCount" :key="`empty-${d}`" class="rating-dot empty" />
  </span>
</template>

<script lang="ts" setup>
import PlayerHelper from '@/core/helpers/player.helper';
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    rating: number;
    maxDots?: number;
  }>(),
  { maxDots: 3 },
);

const dotCount = computed(() => PlayerHelper.ratingToDots(props.rating));
</script>

<style lang="scss" scoped>
.gam-rating-dots {
  display: inline-flex;
  gap: 3px;
  align-items: center;
}

.rating-dot {
  width: 6px;
  height: 6px;
  border-radius: 1px;

  &.filled {
    background: currentColor;
  }

  &.empty {
    border: 1.5px solid currentColor;
    opacity: 0.4;
    background: transparent;
  }
}
</style>
